module.exports = __webpack_public_path__ + "resources/2.2.3/media/logo-qobuz.630f9c4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/logo-qobuz.jpg
// module id = 966
// module chunks = 0